export { InputGroup } from './InputGroup';
export { InputRightAddon, InputLeftAddon } from './InputAddons';
import InputMain from './Input';
const InputTemp = InputMain; // To add typings

const Input = InputTemp;
export { Input };
//# sourceMappingURL=index.js.map